import {
  Center,
  Container,
  Flex,
  Heading,
  Image,
  Select,
  Stack,
  Td,
  Text,
  Tr,
  useDisclosure,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from "@chakra-ui/react";
import { FiDownload } from "react-icons/fi";
import { FiEye, FiEdit3 } from "react-icons/fi";
import React, { useEffect, useState } from "react";
import CustomButton from "../../components/CustomButton";
import useFetchApi from "../../Hooks/useFetchApi";
import Loader from "../../components/Loader";
import TableView from "../../components/TableView";
import TableHeader from "../../components/TableHeader";
import useDebounce from "../../Hooks/useDebounce";
import CustomToolTip from "../../components/CustomTooltip";
import { update_queries } from "../../utils/apis";
import { toast } from "react-toastify";
import CustomPopup from "../../components/CustomPopup";
import CustomInput from "../../components/CustomInput";
import HeadingLayout from "../../components/HeadingLayout";
import useTableControls from "../../Hooks/useTableControls";
import * as XLSX from "xlsx"; // ✅ added for export feature

const headData = [
  "Full Name",
  "Mobile",
  "Email",
  "State",
  "City",
  "Query",
  "Date",
  "Query Assigned",
];

const Queries = () => {
  const [employees, setEmployees] = useState([]);
  const [loadingAssign, setLoadingAssign] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  const {
    rows,
    setRows,
    page,
    setPage,
    search,
    setSearch,
    debouncedSearch,
    id,
    setId,
    value,
    setValue,
    text,
    setText,
    loading,
    setLoading,
  } = useTableControls();

  const {
    isOpen: isCOpen,
    onOpen: onCOpen,
    onClose: onCClose,
  } = useDisclosure();
  const {
    isOpen: isCOpen1,
    onOpen: onCOpen1,
    onClose: onCClose1,
  } = useDisclosure();
  const {
    isOpen: isMessageOpen,
    onOpen: onMessageOpen,
    onClose: onMessageClose,
  } = useDisclosure();
  const [fullMessage, setFullMessage] = useState("");

  const loggedInUser = localStorage.getItem("userId");
  const user = loggedInUser ? JSON.parse(loggedInUser) : {};
  const { permissions, super_admin, userid } = user;

  const {
    data,
    isLoading,
    refetch: handleFetchData,
  } = useFetchApi({
    path: "contact_us.php",
    formDataArr: {
      action: "list",
      limit: rows,
      page: page,
      type: value,
      value: debouncedSearch,
      is_super_admin: super_admin ? "1" : "0",
      assigned_to: super_admin ? "" : userid,
    },
  });

  const fetchEmployees = async () => {
    try {
      const formData = new FormData();
      formData.append("action", "list");
      formData.append("limit", "100");
      formData.append("page", "1");
      formData.append("type", "All");
      formData.append("value", "");

      const response = await fetch(
        "https://websiteadmin.insugo.in/api/insugo/employee.php",
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await response.json();
      if (result.success) {
        // Filter employees to only include those with "queries" permission
        const filteredEmployees = (result.data || []).filter((emp) => {
          const permissions = emp.permissions ? emp.permissions.split(",") : [];
          return permissions.includes("queries");
        });
        setEmployees(filteredEmployees);
      }
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  useEffect(() => {
    handleFetchData();
    fetchEmployees();
  }, [page, rows, debouncedSearch]);

  const update_status = async (id, text) => {
    try {
      setLoading(true);
      const body = new FormData();
      body.append("action", "status");
      body.append("id", id);
      body.append("status", text);
      update_queries(body).then((v) => {
        if (v.success) {
          handleFetchData();
        }
      });
    } catch (error) {
      console.log("error ===", error);
    } finally {
      setLoading(false);
    }
  };

  const update_comment = async (id, text) => {
    try {
      setLoading(true);
      const body = new FormData();
      body.append("action", "comment");
      body.append("id", id);
      body.append("comment", text);
      update_queries(body).then((v) => {
        if (v.success) {
          handleFetchData();
          onCClose();
        }
      });
    } catch (error) {
      console.log("error ===", error);
    } finally {
      setLoading(false);
    }
  };

  const assignQuery = async (queryId, employeeId) => {
    try {
      setLoadingAssign(true);
      const formData = new FormData();
      formData.append("action", "assigned");
      formData.append("id", queryId);
      formData.append("assigned", employeeId);

      const response = await fetch(
        "https://websiteadmin.insugo.in/api/insugo/contact_us.php",
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await response.json();
      if (result.success) {
        toast.success("Query assigned successfully");
        handleFetchData(); // Refresh the data
      } else {
        toast.error(result.message || "Failed to assign query");
      }
    } catch (error) {
      console.error("Error assigning query:", error);
      toast.error("Failed to assign query");
    } finally {
      setLoadingAssign(false);
    }
  };

  // ✅ EXPORT FUNCTION
  const handleExport = (type) => {
    if (!data?.data || data.data.length === 0) {
      toast.warn("No data to export!");
      return;
    }

    const exportData = data.data.map((v) => ({
      "Full Name": `${v.first_name} ${v.last_name}`,
      Mobile: v.mobile,
      Email: v.email,
      State: v.state || "-",
      City: v.city || "-",
      Query: v.message,
      Date: v.datetime || "-",
      Status: v.status || "InProcess",
      Comment: v.comment || "-",
    }));

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Queries");

    if (type === "csv") {
      XLSX.writeFile(wb, "queries_report.csv");
    } else {
      XLSX.writeFile(wb, "queries_report.xlsx");
    }
  };

  return (
    <Container h={"full"} w={"full"} maxW={"full"}>
      <HeadingLayout
        title={"Queries"}
        sNot={true}
        btnNot={true}
        totalCount={data?.totalCount}
      />

      {data?.totalCount > 0 && (
        <Flex gap={4} align="center" mb={4}>
          <Flex flex={1}>
            <TableHeader
              filterValue={value}
              exprtData={false}
              placeholder={`Search Queries`}
              value={search}
              onSerchChange={(v) => {
                setPage(1);
                setRows(10);
                setSearch(v.target.value);
              }}
              data={["All", ...headData]}
              onChange={(e) => {
                setSearch("");
                setPage(1);
                setRows(10);
                setValue(e.target.value);
              }}
            />
          </Flex>

          {data?.data?.length > 0 && (
            <Menu>
              <MenuButton
                as={Button}
                leftIcon={<FiDownload />}
                bg={"#FFBF00"}
                color={"#FFF"}
                _hover={{ bg: "#FFBF0099" }}
                size="md"
                borderRadius="md"
                px={6}
                h="40px"
                minW="120px"
                fontWeight={"bold"}
              >
                Export
              </MenuButton>
              <MenuList>
                <MenuItem onClick={() => handleExport("csv")}>
                  Export as CSV
                </MenuItem>
                <MenuItem onClick={() => handleExport("xlsx")}>
                  Export as Excel
                </MenuItem>
              </MenuList>
            </Menu>
          )}
        </Flex>
      )}

      {isLoading && data?.data?.length === 0 ? (
        <Loader />
      ) : data?.data?.length === 0 ||
        (!super_admin && !data?.data?.some((v) => v.assigned === userid)) ? (
        <Center bg={"#fff"} borderRadius={10}>
          <Stack spacing={4} align="center">
            <Image src="no-data.jpg" h={"md"} objectFit={"contain"} />
            <Text color="gray.600" fontSize="lg">
              {data?.data?.length === 0
                ? "No queries found"
                : "No queries assigned to you"}
            </Text>
          </Stack>
        </Center>
      ) : (
        <>
          <TableView
            pagination={true}
            initialValue={page * rows - rows + 1}
            rows={rows}
            page={page}
            onNext={() => {
              if (
                page <
                Math.ceil(
                  (search ? data?.searchCount : data?.totalCount) / rows
                )
              ) {
                setPage(page + 1);
              }
            }}
            onPrevious={() => {
              if (page > 1) {
                setPage(page - 1);
              }
            }}
            onChange={(e) => {
              setPage(1);
              setRows(e.target.value);
            }}
            total_value={search ? data?.searchCount : data?.totalCount}
            headData={["S.No.", ...headData, "Status", "Comment"]}
            body={data?.data
              ?.filter((v) => super_admin || v.assigned === userid)
              .map((v, i) => (
                <Tr key={i}>
                  <Td textAlign={"center"}>{i + 1 + rows * (page - 1)}</Td>
                  <Td textAlign={"center"}>
                    {v?.first_name} {v?.last_name}
                  </Td>
                  <Td textAlign={"center"}>{v?.mobile}</Td>
                  <Td textAlign={"center"}>{v?.email}</Td>
                  <Td textAlign={"center"}>{v?.state || "-"}</Td>
                  <Td textAlign={"center"}>{v?.city || "-"}</Td>
                  <Td textAlign={"left"}>
                    <Text
                      cursor={
                        v?.message && v.message.split(" ").length > 8
                          ? "pointer"
                          : "default"
                      }
                      onClick={() => {
                        if (v?.message && v.message.split(" ").length > 8) {
                          setFullMessage(v.message);
                          onMessageOpen();
                        }
                      }}
                      color={
                        v?.message && v.message.split(" ").length > 8
                          ? "black"
                          : "inherit"
                      }
                      _hover={
                        v?.message && v.message.split(" ").length > 8
                          ? { textDecoration: "underline" }
                          : {}
                      }
                    >
                      {v?.message && v.message.split(" ").length > 8
                        ? v.message.split(" ").slice(0, 8).join(" ") + "......."
                        : v?.message}
                    </Text>
                  </Td>
                  <Td textAlign={"center"}>
                    {v?.datetime ? v.datetime.split(" ")[0] : "-"}
                  </Td>
                  <Td textAlign={"center"} w={"36"}>
                    {super_admin ? (
                      <Select
                        w={"32"}
                        size={"sm"}
                        borderRadius={"md"}
                        value={v.assigned || ""}
                        onChange={(e) => assignQuery(v.id, e.target.value)}
                        isDisabled={loadingAssign}
                        bg="white"
                      >
                        <option value="">Select Employee</option>
                        {employees.map((emp) => (
                          <option key={emp.id} value={emp.id}>
                            {emp.username}
                          </option>
                        ))}
                      </Select>
                    ) : (
                      <Text>Assigned to you</Text>
                    )}
                  </Td>
                  <Td textAlign={"center"} w={"36"}>
                    <Select
                      w={"32"}
                      size={"sm"}
                      borderRadius={"md"}
                      value={v.status == "" ? "InProcess" : v.status}
                      onChange={(e) => update_status(v.id, e.target.value)}
                    >
                      <option value="InProcess">In Process</option>
                      <option value="Not Responding">Not Responding</option>
                      <option value="Converted">Converted</option>
                      <option value="Not Intrested">Not Intrested</option>
                    </Select>
                  </Td>
                  <Td textAlign={"center"}>
                    <Flex gap={2}>
                      <CustomToolTip
                        button={
                          <FiEye
                            size={20}
                            cursor={"pointer"}
                            onClick={() => {
                              setId(v.id);
                              setText(v.comment);
                              onCOpen1();
                            }}
                          />
                        }
                        mess={"View Comment"}
                      />
                      <CustomToolTip
                        button={
                          <FiEdit3
                            size={20}
                            cursor={"pointer"}
                            onClick={() => {
                              setId(v.id);
                              setText(v.comment);
                              onCOpen();
                            }}
                          />
                        }
                        mess={"Edit Comment"}
                      />
                    </Flex>
                  </Td>
                </Tr>
              ))}
          />
        </>
      )}

      <CustomPopup
        isOpen={isCOpen1}
        onClose={onCClose1}
        title={"Comment"}
        single_button
        mess={
          <Stack>
            {text.length == 0 ? (
              <Text>No Comment, Please add comment</Text>
            ) : (
              <Text>{text}</Text>
            )}
          </Stack>
        }
      />
      <CustomPopup
        isOpen={isCOpen}
        onClose={onCClose}
        title={"Comment"}
        b_name={"Update"}
        onClick={() => update_comment(id, text)}
        b_color={"#FFBF00"}
        loading={loading}
        mess={
          <Stack>
            {text.length == 0 && <Text>No Comment, Please add comment</Text>}
            <CustomInput
              area1
              onlyone
              value1={text}
              onChange1={(e) => setText(e.target.value)}
              placeholder1={"Enter Comment..."}
            />
          </Stack>
        }
      />
      <CustomPopup
        isOpen={isMessageOpen}
        onClose={onMessageClose}
        title={"Full Query Message"}
        single_button
        mess={
          <Stack>
            <Text>{fullMessage}</Text>
          </Stack>
        }
      />
    </Container>
  );
};

export default Queries;
